export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00550.6168b69c.png";